module.exports = __webpack_public_path__ + "static/media/Lisa Seaman.f5479118.png";